import React from 'react'

function AboutUs() {
  return (
    <section id="aboutus">
    <div className="container-fluid padding mt-5">
      <div className="row welcome text-center">
        <div className="col-12">
          <h1 className="display-4 mb-4">ABOUT US</h1>
        </div>
        <hr />
        <div className="col-12">
          <p className="lead mt-5">
            Aryavart Expo staffing solutions is one of the few IT system
            integration, profes- sional service and software development
            companies in India that works with Enterprise systems and
            companies. As a privately owned company, Aryavart Expo staffing
            Solutions provides IT Consultancy, software design and development
            as well as professional and Recruitment services. 
            Founded by a team of young, dynamic and task-oriented IT profession- as
            <ul type="" style={{textAlign: "left"}}>
              <li> High-end business and IT consulting with a focus on digital.</li>
              <li>Systems integration to connect legacy assets with digital business
                and operating models.</li>
                <li>
                  Transformational outsourcing to improve both
            how they run and change their organizations. 
                </li>
                <li>
                  Intellectual property
            that acts as a digital business accelerator.
                </li>
            </ul>
             
          </p>
          <p className="lead mt-5">
            Aryavart Expo Staffing Solutions and Services organization focused
            on creating relevant, effective, and result-oriented learning
            products for the Classroom, Web, and Mobile. Using the latest
            pedagogical approaches and technology innovations, Aryavart offers
            the best of both worlds in its learning solutions.
          </p>
        </div>
      </div>
    </div>
  </section>
  )
}

export default AboutUs
